module.exports = __webpack_public_path__ + "static/media/lateralhead_severe_right.416e2b1e.png";